import Handsontable from 'handsontable';

export default function isFirstRowOfEntry(visualRow: number, instance: Handsontable) {
  const rowId = instance.getDataAtRowProp(visualRow, 'id');
  const previousRowId = instance.getDataAtRowProp(visualRow - 1, 'id');

  return rowId !== previousRowId;
}
